import React from 'react';
import { ArrowLeft } from 'lucide-react';

export function BackLink({ text, onClick }: { text: string; onClick: () => void }): React.ReactElement {
  return (
    <div onClick={onClick} className="mb-3 flex cursor-pointer items-center gap-1.5 text-small text-sub hover:text-ink">
      <ArrowLeft size={14} /> <span>{text}</span>
    </div>
  );
}
